module.exports = "/_next/static/images/lr-cf309785b8e51623b4d44d24153580b5.svg";